var domHelpers = require("../../utils/dom_helpers");

var createMouseHandler = (function(domHelpers) {
	return function (gantt) {
		var eventHandlers = {
			"click": {},
			"doubleclick": {},
			"contextMenu": {}
		};

		function addEventTarget(event, className, handler, root) {
			if(!eventHandlers[event][className]){
				eventHandlers[event][className] = [];
			}

			eventHandlers[event][className].push({
				handler: handler,
				root: root
			});
		}

		function callHandler(eventName, className, root, args) {
			var handlers = eventHandlers[eventName][className];
			if(handlers){
				for(var i = 0; i < handlers.length; i++){
					if(!root || root == handlers[i].root == root){
						handlers[i].handler.apply(this, args);
					}
				}
			}
		}

		function onClick(e) {
			e = e || window.event;
			var trg = e.target || e.srcElement;
			var id = gantt.locate(e);

			var res = true;
			if (id !== null) {
				res = !gantt.checkEvent("onTaskClick") || gantt.callEvent("onTaskClick", [id, e]);
			} else {
				gantt.callEvent("onEmptyClick", [e]);
			}

			var targets = eventHandlers.click;

			if (res) {
				var default_action = findEventHandler(e, trg, targets, id);
				if (!default_action)
					return;

				if (id && gantt.getTask(id) && gantt.config.select_task) {
					gantt.selectTask(id);
				}
			}
		}

		function onContextMenu(e) {
			e = e || window.event;
			var src = e.target || e.srcElement,
				taskId = gantt.locate(src),
				linkId = gantt.locate(src, gantt.config.link_attribute);

			var res = !gantt.checkEvent("onContextMenu") || gantt.callEvent("onContextMenu", [taskId, linkId, e]);
			if (!res) {
				if (e.preventDefault)
					e.preventDefault();
				else
					e.returnValue = false;
			}
			return res;
		}

		function findEventHandler(e, trg, hash, id) {
			var res = true;
			while (trg) {
				var css = domHelpers.getClassName(trg);
				if (css) {
					css = css.split(" ");
					for (var i = 0; i < css.length; i++) {
						if (!css[i]) continue;
						if (hash[css[i]]) {
							var delegateHandlers = hash[css[i]];

							for(var h = 0; h < delegateHandlers.length; h++){
								if(delegateHandlers[h].root){
									if(!domHelpers.isChildOf(trg, delegateHandlers[h].root)){
										continue;
									}
								}
								var handler = delegateHandlers[h].handler.call(gantt, e, id, trg);
								res = res && !(typeof handler != "undefined" && handler !== true);
							}
						}
					}
				}
				trg = trg.parentNode;
			}
			return res;
		}

		function onDoubleClick(e) {
			e = e || window.event;
			var trg = e.target || e.srcElement;
			var id = gantt.locate(e);
			var res = !gantt.checkEvent("onTaskDblClick") || gantt.callEvent("onTaskDblClick", [id, e]);
			if (res) {
				var default_action = findEventHandler(e, trg, eventHandlers.doubleclick, id);
				if (!default_action)
					return;

				if (id !== null && gantt.getTask(id)) {
					if (res && gantt.config.details_on_dblclick) {
						gantt.showLightbox(id);
					}
				}
			}
		}

		function onMouseMove(e) {
			if (gantt.checkEvent("onMouseMove")) {
				var id = gantt.locate(e);
				gantt._last_move_event = e;
				gantt.callEvent("onMouseMove", [id, e]);
			}
		}

		function detach(eventName, className, handler, root) {
			if (eventHandlers[eventName]) {
				for(var i = 0; i < eventHandlers[eventName].length; i++){
					if(eventHandlers[eventName][i].root == root){
						eventHandlers[eventName].splice(i, 1);
						i--;
					}
				}
			}
		}

		var globalHandlers = [];

		function reset(node){

			for(var i = 0; i < globalHandlers.length; i++){
				gantt.eventRemove(globalHandlers[i][0], globalHandlers[i][1], globalHandlers[i][2]);
			}
			globalHandlers = [];

			if(node){
				globalHandlers.push([node, "click", onClick]);
				globalHandlers.push([node, "dblclick", onDoubleClick]);
				globalHandlers.push([node, "mousemove", onMouseMove]);
				globalHandlers.push([node, "contextmenu", onContextMenu]);
				for(var i = 0; i < globalHandlers.length; i++){
					gantt.event(globalHandlers[i][0], globalHandlers[i][1], globalHandlers[i][2]);
				}
			}
		}



		return {
			reset: reset,
			global: function(event, classname, handler){
				addEventTarget(event, classname, handler, null);
			},
			delegate: addEventTarget,
			detach: detach,
			callHandler: callHandler,
			onDoubleClick: onDoubleClick,
			onMouseMove: onMouseMove,
			onContextMenu: onContextMenu,
			onClick: onClick

		};
	};

})(domHelpers);


module.exports = {
	init:createMouseHandler
};


//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/mouse.js
// module id = 32
// module chunks = 0